export default {
  methods: {
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
  },
};